import $axios from './api';

export const create = async (course) => {

	const { data } = await $axios.post('/v1/author/course/create', course);
	return data;
};

export const list = async () => {

	// const { data } = await $axios.post('/v1/author/course/list', { limit, page, sortBy, sortDirection });
	const { data } = await $axios.post('/v1/author/course/list', {});
	return data;

};

export const getById = async (id) => {
	console.log('courses.getById вызван с ID:', id);
	const url = `/v1/author/course/${id}`;
	console.log('Отправляем запрос на URL:', url);
	
	const { data } = await $axios.get(url);
	return data;

};

export const update = async (id, payload) => {

	const { data } = await $axios.post(`/v1/author/course/${id}`, payload);
	return data;
	
};